import { useCallback } from 'react'
import { useToggleTakingNotes } from '@renderer/hooks/audio/useAudioNoteState'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'

export const useStopAudioNote = () => {
  const toggleTakingNotes = useToggleTakingNotes()

  return useCallback(async () => {
    toggleTakingNotes()

    AmplitudeRenderer.trackEvent('Floating Window', {
      action: 'Stopped audio notes',
      source: 'audioMenu',
    })
  }, [toggleTakingNotes])
}
